import script from "./StepReview.vue?vue&type=script&setup=true&lang=js"
export * from "./StepReview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import WizardIcon from "@/components/neue/wizard/WizardIcon.vue";
script.components = Object.assign({}, { HighlightedText, WizardIcon }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HighlightedText, WizardIcon }, script.__o.components);}